import React from 'react';
// Visa-Free Projection
const FourteenStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    country_name,
    visa_free_guide_link,
    registration_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
    <p>Hi {client_name?client_name:`[Lead's Name]`},</p>
      <p>
        We are delighted to inform you that{' '}
        <strong>
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}
        </strong>{' '}
        offers <strong>visa-free entry</strong> for participants from{' '}
        <strong> {country_name ? country_name : `[Your Country]`}</strong>,
        allowing you to attend without the hassle of applying for a visa.
      </p>

      <p>
        To ensure a seamless travel experience, please refer to our guide for
        more details on the visa-free process:{' '}
          {visa_free_guide_link ? (
            <a
              href={visa_free_guide_link}
              target="_blank"
              rel="noopener noreferrer"
            >
             {visa_free_guide_link}
            </a>
          ) : (
            `[Link to Visa-Free Guide]`
          )}
        .
      </p>

      <p>
        {registration_link ? (
          <>
            Register now to secure your spot:{' '}
            <a
              href={registration_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {registration_link}
            </a>
          </>
        ) : (
            `Register now to secure your spot: [Registration Link].`
        )}
      </p>

      <p>
        Should you have any questions, please don’t hesitate to reach out. We
        look forward to welcoming you to the conference.
      </p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default FourteenStepWhatsappTemplate;
